document.addEventListener('click', function (event) {
    const button = event.target instanceof Element
        ? event.target.closest('.dfd-back-to-top-button[data-dfd-role="back-to-top"]')
        : null;
    const embedded = button && button.closest('.dfd-root.dfd-embedded');
    if (!embedded) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    let target = document.getElementById(button.getAttribute('dfd-value-target') || '');
    if (!target || !embedded.contains(target)) target = embedded;

    let scrollContainer = null;
    for (let node = target; node && embedded.contains(node); node = node.parentElement) {
        if (node.scrollHeight > node.clientHeight + 1 &&
            /^(auto|scroll|overlay)$/.test(window.getComputedStyle(node).overflowY)) {
            scrollContainer = node;
            break;
        }
    }

    (scrollContainer || window).scrollTo({
        top: 0,
        left: scrollContainer ? scrollContainer.scrollLeft : window.scrollX,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
    });
}, true);

var $ = jQuery;
window.tgdInitProductGallery = function(root) {
    var $root = $(root);
    var $gallery = $root.find('.product-single__gallery').first();
    if (!$gallery.length || !$.fn.flickity) return;
    var $thumbnails = $root.find('.product-single__thumbnails li');
    var count = $gallery.find('.product-single__gallery-item').length;
    $root.off('.tgdGallery');
    $gallery.off('.tgdGallery');
    function updateThumbnail(index) {
        $thumbnails.removeClass('active');
        $thumbnails.eq(index).addClass('active');
    }
    if (count > 1) {
        if (!$gallery.data('flickity')) {
            $gallery.flickity({
                imagesLoaded: true,
                groupCells: false,
                dragThreshold: 5,
                cellAlign: 'center',
                wrapAround: true,
                prevNextButtons: true,
                percentPosition: true,
                pageDots: true,
                rightToLeft: false,
                autoPlay: false
            });
        }
        $gallery.on('change.flickity.tgdGallery', function(event, index) {
            updateThumbnail(index);
        });
        $root.on('click.tgdGallery', '.product-single__thumbnails li', function() {
            var index = $thumbnails.index(this);
            if (index >= 0) $gallery.flickity('select', index);
        });
        $root.on('click.tgdGallery', '.product__thumb-arrow', function() {
            var step = this.classList.contains('product__thumb-arrow--next') ? 1 : -1;
            var index = Math.max(0, Math.min($thumbnails.length - 1, $thumbnails.index($thumbnails.filter('.active')) + step));
            $gallery.flickity('select', index);
            var item = $thumbnails.eq(index);
            var list = $root.find('.product-single__thumbnails');
            if (item.length) list.stop(true).animate({scrollTop: item.position().top + list.scrollTop() - 20}, 200);
        });
        $gallery.flickity('select', 0, false, true);
    }
    updateThumbnail(0);
};

$(document).ready(function() {
    $(document).on('click', '.drawer-menu-title + .svg-wrapper', function () {
        $('.menu-drawer').addClass('active');
    });
    $(document).on('click', '.menu-drawer__inner-submenu .menu-drawer__close-button', function () {
        $('.menu-drawer').removeClass('active');
    });
    $(document).on('click', '.js-back-to-top', function (event) {
        event.preventDefault();
        // A single native scroll avoids competing html/body animations.
        $('html, body').stop(true, false);
        window.scrollTo({
            top: 0,
            left: window.scrollX,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
    });
    $(document).on('click', '.acctab_title', function(e) {
        if ($(window).width() >= 768) {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        } else {
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click', '.acc_tab-inner .acc-tab-content .back__arrow', function(e) {
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.footer-block.has-dropdown .footer-block__heading').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
    });
    $('.acc-head').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        } else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    $(document).on('click', 'span.click-down', function(e) {
        $(this).hide();
        $('.testimonials-slider').addClass('active');
    });
    document.querySelectorAll('.header__inline-menu .mega-menu__content').forEach((panel) => {
        const hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        const details = panel.closest('details');
        const lists = new Map();
        let closeTimer = null;

        const cancelClose = () => {
            clearTimeout(closeTimer);
            closeTimer = null;
        };
        const cancelSwitches = () => {
            lists.forEach((timer) => clearTimeout(timer));
            lists.clear();
        };
        const reset = () => {
            cancelClose();
            cancelSwitches();
            panel.querySelectorAll('.mega-menu__list').forEach((list) => list.classList.remove('active'));
            panel.querySelectorAll('a.showing, a.active').forEach((link) => link.classList.remove('showing', 'active'));
        };
        const selectLink = (link, list, firstLevel) => {
            const state = firstLevel ? 'showing' : 'active';
            list.querySelectorAll(':scope > li > a').forEach((other) => {
                if (other === link) return;
                other.classList.remove(state);
                other.parentElement.querySelectorAll('a.showing, a.active').forEach((child) => child.classList.remove('showing', 'active'));
            });
            const hasChildren = link.classList.contains(firstLevel ? 'has_sub' : 'has_sub_2');
            link.classList.toggle(state, hasChildren);
            if (firstLevel) list.classList.toggle('active', hasChildren);
        };

        panel.querySelectorAll('ul.mega-menu__list > li > a, ul.sub-menu > li > a').forEach((link) => {
            const list = link.parentElement.parentElement;
            const firstLevel = list.classList.contains('mega-menu__list');
            if (!firstLevel && list.classList.contains('sub-menu-2')) return;

            const cancelSwitch = () => {
                clearTimeout(lists.get(list));
                lists.delete(list);
            };
            link.addEventListener('mouseenter', () => {
                cancelClose();
                cancelSwitch();
                if (!hoverMedia.matches) return;
                lists.set(list, setTimeout(() => {
                    lists.delete(list);
                    if (!hoverMedia.matches || !details?.hasAttribute('open') || !link.isConnected || !link.matches(':hover')) return;
                    selectLink(link, list, firstLevel);
                }, 120));
            });
            link.addEventListener('mouseleave', cancelSwitch);
            link.addEventListener('focusin', () => {
                cancelClose();
                cancelSwitch();
                selectLink(link, list, firstLevel);
            });
        });

        panel.addEventListener('mouseenter', cancelClose);
        panel.addEventListener('mouseleave', () => {
            cancelClose();
            cancelSwitches();
            if (!hoverMedia.matches) return;
            closeTimer = setTimeout(() => {
                closeTimer = null;
                if (!panel.matches(':hover') && !panel.matches(':focus-within')) reset();
            }, 220);
        });
        details?.addEventListener('toggle', () => {
            if (!details.hasAttribute('open')) reset();
        });
        hoverMedia.addEventListener('change', reset);
    });
    document.querySelectorAll('media-gallery').forEach(window.tgdInitProductGallery);

    $(document).on('click', 'button.tzn-read-more.button.button--secondary', function(e) {
        $(this).hide();
        $('.tzn-text-card-wrap').addClass('showing');
    });
    //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".announcement-bar .slider--everywhere,.testimonials-slider,.mission_st_slider .multicolumn-list");
        var $lists_left = $(".menu-shop");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: true,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'center'
                    });
                }
            });
            $lists_left.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: false,
                        prevNextButtons: true,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_left.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});

/*** LOAD MORE **/
$(document).on('click', '[data-pagination-link]', function(e) {
    e.preventDefault();

    const $button = $(this);
    const nextUrl = $button.attr('href');

    $button.text("Laden...");
    $button.prop('disabled', true);

    $.get(nextUrl, function(response) {
        const $tempDiv = $('<div>').html(response);
        const newProductsHtml = $tempDiv.find('#product-grid').html();
        const $newWrapper = $tempDiv.find('.show_more_btn');

        $('#product-grid').append(newProductsHtml);

        const currentLoadedCount = $('#product-grid > .grid__item').length;
        $('.loaded-count').text(currentLoadedCount);

        $('.show_more_btn').remove();

        if ($newWrapper.length) {
            $('#product-grid').after($newWrapper);
        }

    }).fail(function() {
        console.error('Error loading more products.');
        $button.text("Try again");
        $button.prop('disabled', false);
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var btn = document.getElementById('show-more-menu');
    if (btn) {
      btn.addEventListener('click', function() {
        var hiddenItems = document.querySelectorAll('.menu-item-hidden');
        hiddenItems.forEach(function(item) {
          item.classList.remove('menu-item-hidden');
        });
        btn.style.display = 'none';
      });
    }
  });

  class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

window.customElements.define("price-range1", PriceRange1);


document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-syndikat-atc]');

  if (!button || button.disabled) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;

  button.disabled = true;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: 1
        }
      ]
    })
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      return response.json();
    })
    .then(function () {
      sessionStorage.setItem('openMiniCartAfterReload', 'true');

      window.location.reload();
    })
    .catch(function (error) {
      console.error(error);
      button.disabled = false;
    });
});


document.addEventListener('DOMContentLoaded', function () {
  if (
    sessionStorage.getItem('openMiniCartAfterReload') !== 'true'
  ) {
    return;
  }

  sessionStorage.removeItem('openMiniCartAfterReload');

  setTimeout(function () {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    const cartIcon = document.querySelector(
      '#cart-icon-bubble, .header__icon--cart'
    );

    if (cartIcon) {
      cartIcon.click();
    }
  }, 300);
});

function initMobileMenuLinkAndArrow() {
  const mobileBreakpoint = window.matchMedia('(max-width: 989px)');

  document.querySelectorAll('header-drawer').forEach((drawer) => {
  
    if (drawer.dataset.mobileMenuLinkInitialized === 'true') return;

    drawer.dataset.mobileMenuLinkInitialized = 'true';

    drawer.addEventListener(
      'click',
      function (event) {
        if (!mobileBreakpoint.matches) return;

        const summary = event.target.closest('summary');

        if (!summary || !drawer.contains(summary)) return;

        const mainDetails = drawer.querySelector(
          ':scope > details'
        );

        const hamburgerSummary = mainDetails?.querySelector(
          ':scope > summary'
        );

        if (summary === hamburgerSummary) return;

        const navigationLink = event.target.closest(
          '.menu-drawer__navigation-link'
        );

        const arrowButton = event.target.closest(
          '.menu-drawer__submenu-toggle'
        );

        if (navigationLink) {
          event.stopPropagation();

          if (
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }

          event.preventDefault();
          window.location.assign(navigationLink.href);
          return;
        }

        if (arrowButton) return;

        if (event.detail !== 0) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initMobileMenuLinkAndArrow
  );
} else {
  initMobileMenuLinkAndArrow();
}

(() => {
  'use strict';

  const tgdPreorderPriceRoots = new WeakMap();
  const selector = '.product__info-container [id^="price-"].custom-price';

  function amount(text) {
    const parts = String(text || '').replace(/[^0-9.,-]/g, '').split(/[.,]/);
    const fraction = parts.length > 1 && parts.at(-1).length <= 2 ? parts.pop() : null;
    const value = Number(parts.join('') + (fraction === null ? '' : '.' + fraction));
    return Number.isFinite(value) ? value : 0;
  }

  function update(root) {
    const nativeCompare = root.querySelector('.tgd-price-compare .price-item--regular');
    const rrp = nativeCompare?.textContent.match(/^[^0-9]+/)?.[0]?.trim();

    root.querySelectorAll('.hengam-product-price-wrapper').forEach((wrapper) => {
      const finalPrice = wrapper.querySelector('.hengam-final-price');
      const comparePrice = wrapper.querySelector('.hengam-pre-discount-price');
      const price = amount(finalPrice?.textContent);
      const compare = amount(comparePrice?.textContent);
      let saving = wrapper.querySelector('.tgd-preorder-price-saving');

      if (!finalPrice || !comparePrice || compare <= price || price <= 0 || !rrp) {
        if (wrapper.hasAttribute('data-tgd-sale')) wrapper.removeAttribute('data-tgd-sale');
        if (comparePrice?.hasAttribute('data-tgd-rrp')) comparePrice.removeAttribute('data-tgd-rrp');
        if (saving) saving.remove();
        return;
      }

      if (wrapper.dataset.tgdSale !== 'true') wrapper.dataset.tgdSale = 'true';
      if (comparePrice.dataset.tgdRrp !== rrp) comparePrice.dataset.tgdRrp = rrp;
      if (!saving) {
        saving = document.createElement('span');
        saving.className = 'tgd-preorder-price-saving';
        wrapper.append(saving);
      }
      const text = '- ' + Math.round((compare - price) * 100 / compare) + ' %';
      if (saving.textContent !== text) saving.textContent = text;
    });
  }

  function init(scope = document) {
    scope.querySelectorAll(selector).forEach((root) => {
      if (tgdPreorderPriceRoots.has(root)) return;
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          if (root.isConnected) update(root);
        });
      });
      tgdPreorderPriceRoots.set(root, observer);
      update(root);
      observer.observe(root, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => {
      tgdPreorderPriceRoots.get(root)?.disconnect();
      tgdPreorderPriceRoots.delete(root);
    });
  });
})();

if (!customElements.get('tzn-klaviyo-newsletter')) {
  customElements.define('tzn-klaviyo-newsletter', class extends HTMLElement {
    connectedCallback() {
      if (this.boundSubmit) return;
      this.boundSubmit = this.onSubmit.bind(this);
      this.addEventListener('submit', this.boundSubmit);
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.boundSubmit);
      this.boundSubmit = null;
    }

    async onSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.submitting || this.submitted) return;
      if (!form.reportValidity()) return;

      const status = form.querySelector('[data-newsletter-status]');
      const button = form.querySelector('button[type="submit"]');
      const email = form.elements.namedItem('email');
      const consent = form.elements.namedItem('tgd_email_consent');
      const list = form.elements.namedItem('g');
      const siteId = form.dataset.klaviyoSiteId;
      if (!status || !button || !email || !list) return;
      status.hidden = true;
      if ((consent && !consent.checked) || !siteId || !list.value) {
        this.showStatus(status, form.dataset.errorMessage, true);
        return;
      }

      const consentLabel = consent?.labels?.[0]?.textContent.trim();
      const properties = {
        'TGD Newsletter form': form.id,
        'TGD Newsletter consent version': 'theme-2026-10-23'
      };
      if (consent) {
        properties['TGD Newsletter email consent'] = consent.checked;
        properties['TGD Newsletter consent text'] = consentLabel || '';
      }
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.klaviyoSource,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value.trim(),
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  properties
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list.value } } }
        }
      };

      this.submitting = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(siteId), {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-10-15'
          },
          body: JSON.stringify(payload),
          credentials: 'omit',
          signal: controller.signal
        });
        if (response.status !== 202) {
          this.showStatus(status, response.status === 429 ? form.dataset.rateMessage : form.dataset.errorMessage, true);
          return;
        }
        this.submitted = true;
        this.showStatus(status, form.dataset.pendingMessage, false);
      } catch {
        this.showStatus(status, form.dataset.errorMessage, true);
      } finally {
        clearTimeout(timeout);
        this.submitting = false;
        button.disabled = Boolean(this.submitted);
        form.removeAttribute('aria-busy');
      }
    }

    showStatus(status, message, error) {
      status.textContent = message;
      status.setAttribute('role', error ? 'alert' : 'status');
      status.classList.toggle('tzn-newsletter__message--error', error);
      status.classList.toggle('tzn-newsletter__message--success', !error);
      status.hidden = false;
      status.focus();
    }
  });
}

if (!customElements.get('tgd-fastlane-hint')) {
  customElements.define('tgd-fastlane-hint', class extends HTMLElement {
    static isShippingWeekday(date = new Date()) {
      try {
        const weekday = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Berlin',
          weekday: 'short'
        }).format(date);
        return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday);
      } catch {
        return false;
      }
    }

    connectedCallback() {
      if (this.refreshTimer) return;
      this.refreshVisibility = () => {
        this.hidden = this.getAttribute('data-stock-eligible') !== 'true' || !this.constructor.isShippingWeekday();
      };
      this.refreshVisibility();
      this.refreshTimer = setInterval(this.refreshVisibility, 60000);
      document.addEventListener('visibilitychange', this.refreshVisibility);
      window.addEventListener('pageshow', this.refreshVisibility);
    }

    disconnectedCallback() {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
      document.removeEventListener('visibilitychange', this.refreshVisibility);
      window.removeEventListener('pageshow', this.refreshVisibility);
    }
  });
}

